<template>
    <section ref="section4" class="mx-auto flex h-full flex-col">
        <v-register-head
            @previous="3"
            :step="4"
            :landing-route="registrationProcessData.routes.landing"
        ></v-register-head>
        <div
            class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
        >
            <form
                method="POST"
                :action="
                    registrationProcessData.routes.processEmailVerification
                "
                id="submit-email-form"
            >
                <v-csrf-token></v-csrf-token>
                <figure class="flex max-w-lg flex-col gap-11 lg:w-full">
                    <figure class="flex gap-3">
                        <div><v-icon icon="envelope" size="8"></v-icon></div>
                        <div class="flex flex-col justify-center">
                            <div class="mb-3 text-heading-3-desktop">
                                Vpišite svoj elektronski naslov
                            </div>
                            <div class="text-body-regular text-black-40">
                                S tem elektronskim naslovom se boste lahko
                                vpisali v portal
                            </div>
                        </div>
                    </figure>
                    <figure class="flex flex-col gap-3">
                        <v-form-input
                            id="userEmail"
                            :value="user.email"
                            label="Elektronski naslov"
                            type="text"
                            name="userEmail"
                        ></v-form-input>
                        <template v-if="validationErrors.userEmail">
                            <label class="small-text-medium text-red-500">{{
                                validationErrors.userEmail[0] ?? ""
                            }}</label>
                        </template>
                    </figure>
                </figure>
            </form>
        </div>
        <div
            class="sticky bottom-0 z-10 flex max-h-[102px] min-h-[102px] w-full justify-between border-t bg-white px-4 pt-4 lg:max-h-[90px] lg:min-h-[90px]"
        >
            <div class="flex w-full justify-center">
                <a
                    @click="submitForm('submit-email-form')"
                    class="button button--form"
                >
                    <label>Nadaljujte</label>
                    <v-icon icon="arrow-right"></v-icon>
                </a>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        registrationProcessData: {
            type: Object,
            required: true,
        },
        validationErrors: {
            type: Object,
            required: true,
            default: {},
        },
        user: {
            type: Object,
            required: true,
        },
        session: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {};
    },
    computed: {},
    methods: {
        submitForm(formId) {
            document.getElementById(formId).submit();
        },
    },
};
</script>
